import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
import { toast } from 'react-toastify';

export class FreshProducePricing extends React.Component {
  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    products: []
  }

  componentWillMount() {
    this.fetchProducts();
  }

  handleChange (evt) {
    var products = this.state.products
    var index = products.findIndex(e => e.productID == evt.target.name);
    if (!isNaN(evt.target.value)) {
      products[index].newPrice = evt.target.value
    } else {
      if (!products[index].newPrice) {
        products[index].newPrice = ''
      }
    }
    this.setState({ products: products });
  }

  fetchProducts = async () => {
    axios.get('/freshproduce')
        .then(data => {
          this.setState({
            products: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to fetch products')
        })
  }

  saveChanges = async () => {
    let requestParams = {
      'prices': this.state.products
    }
    axios.post('/freshproduce', requestParams)
        .then(data => {
          toast.success('Prices updated!')
          this.props.history.push("/orders")
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to save price changes')
        })
  }

  editPrice(cell, row, enumObject, rowIndex) {
    return (
      <input type="text" className="form-control" name={row.productID} value={row.newPrice} onChange={this.handleChange}/>
    )
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Set Prices for Today's Orders</h1>
            </div>
            <button type="button" onClick={() => this.saveChanges()} className="btn btn-success btn-sm mar-bot mar-right">Save Changes</button>
            <BootstrapTable data={this.state.products} striped={true} hover={true} pagination>
              <TableHeaderColumn dataField="name" isKey={true} dataSort={true} filter={{ type: 'TextFilter' }}>Product Name</TableHeaderColumn>
              <TableHeaderColumn dataField="currentPrice" dataSort={true}>Current Price</TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataFormat={this.editPrice.bind(this)}>New Price</TableHeaderColumn>
            </BootstrapTable>
          </div>
        );
    }
}
